export default "__VITE_ASSET__BnFV8S9i__"